import { SelectOption } from '../types'

export const bedrooms = ['2', '3', '4', '5']

export const bedroomOptions: SelectOption[] = bedrooms.map((bedroom) => ({
  value: bedroom,
  label: bedroom,
}))
